import React, { useState } from "react";
import style from "./style.module.scss";
const PopupDownloadImg = (props) => {
  const { isOpenDownloadImg, srcImg, setIsOpenDownloadImg } = props;
  // const closeModal = () => {
  //   document.body.classList.remove("modal-open");
  //   // localStorage.setItem("accessToken", "");
  //   // localStorage.setItem("userData", JSON.stringify({}));
  //   navigate("/");
  //   // setIsShowModalWhishNote(false);
  // };
  return (
    <>
      {isOpenDownloadImg && (
        <div className="popup-overlay modal-whish">
          <div className="popup-warp">
            <div
              className="close-modal"
              onClick={() => setIsOpenDownloadImg(false)}
            ></div>
            <div className="popup-inner-downloadImg">
              <img src={srcImg} alt="download" />
              <div className="btn-wrapper btn-center">
                <img src="assets/img/bt-wish-note.png" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PopupDownloadImg;
